import React from "react";
import { Logout } from "../../../api";
import { Menu, MenuItem, Avatar, IconButton, ListItemIcon, ListItemText, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessIcon from '@mui/icons-material/Business';
import LogoutIcon from '@mui/icons-material/Logout';
import TableChartIcon from '@mui/icons-material/TableChart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ExtensionIcon from '@mui/icons-material/Extension';
import { useNavigate } from 'react-router-dom';

const initials = name => {
  name = name.split(',')[0]
  return name.split(' ').slice(0,3).map(e=>e[0]).join('')
}

const SubMenu = ({ user, access }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logOut = async (e) => {
    Logout().then(() => navigate('/'));
  }

  const hasAdminSomewhere = React.useMemo(() => user.access.some(e=>e.admin), [user])

  return (
    <>
      <IconButton aria-expanded={open} onClick={handleClick} size="small">
        <Avatar>{initials(user.name)}</Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleClose} component={Link} to="/settings/user">
          <ListItemIcon>
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>User Settings</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/settings/user/notifications">
          <ListItemIcon>
            <NotificationsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Notifications</ListItemText>
        </MenuItem>
        {access.admin && (
          <MenuItem onClick={handleClose} component={Link} to="/settings/org/">
            <ListItemIcon>
              <BusinessIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Org Settings</ListItemText>
          </MenuItem>
        )}
        {access.admin && (
          <MenuItem onClick={handleClose} component={Link} to="/settings/integrations/">
            <ListItemIcon>
              <ExtensionIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Integrations</ListItemText>
          </MenuItem>
        )}
        {access.admin && (
          <MenuItem onClick={handleClose} component={Link} to="/settings/billing/">
            <ListItemIcon>
              <ReceiptLongIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Billing Manager</ListItemText>
          </MenuItem>
        )}
        {hasAdminSomewhere && [
          <MenuItem key="billing-report" onClick={handleClose} component={Link} to="/settings/reports/">
            <ListItemIcon>
              <TableChartIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Billing Report</ListItemText>
          </MenuItem>,
          <MenuItem key="dicom-report" onClick={handleClose} component={Link} to="/settings/reports/studies">
            <ListItemIcon>
              <TableChartIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>DICOM Study Report</ListItemText>
          </MenuItem>
        ]}
        <Divider />
        <MenuItem onClick={(e) => { handleClose(); logOut(e) }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Log out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default SubMenu;
